module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/TV2-a9ebd8413173ed3afc79864f882d0b4c.svg";